import TranslationNS from '@/utils/Constants/TranslationNS'

const LIVE = TranslationNS.LIVE

/**
 * Page tour of the Live Judging settings (route `live/settings`): switch the judge app on, the live
 * session, the screens of the day, who holds which role (one entry per role), the public screen
 * link. Anchors sit on the antd Cards in features/liveJudging/surfaces/Settings/index.jsx.
 */
export const LIVE_SETTINGS_TOUR = {
    id: 'live-settings',
    version: 1,
    paths: ['live/settings'],
    steps: [
        {
            key: 'head',
            target: '[data-tour="page-head"]',
            placement: 'bottom',
            title: 'Live judging settings',
            description:
                'Judges score on a tablet or a phone, and the results reach the ranking live. The text under the title sums up who uses which screen.',
        },
        {
            key: 'enable',
            target: '[data-tour="live-enable"]',
            placement: 'bottom',
            title: 'Turn it on',
            description:
                'This switch opens the screens of the day. Once it is on, workouts are created from the judge app.',
        },
        {
            key: 'session',
            target: '[data-tour="live-session"]',
            placement: 'bottom',
            title: 'What is happening now',
            description: 'The wave being judged and the devices connected. Stop the session at the end of the day.',
        },
        {
            key: 'surfaces',
            target: '[data-tour="live-surfaces"]',
            placement: 'bottom',
            title: 'The screens of the day',
            description: 'Each one opens in a new tab.',
            entries: [
                { label: 'settings.open.headJudge', ns: LIVE, text: 'starts the waves and checks the scores.' },
                { label: 'settings.open.speaker', ns: LIVE, text: 'follows the wave to announce it.' },
                { label: 'settings.open.regie', ns: LIVE, text: 'chooses what the public screen shows.' },
                { label: 'settings.open.judge', ns: LIVE, text: 'where each judge enters the scores.' },
                { label: 'settings.open.screen', ns: LIVE, text: 'the display for the public.' },
            ],
        },
        {
            key: 'roles',
            // the card's title band: one list per role makes the card taller than the screen
            target: '[data-tour="live-roles"]',
            block: '.ant-card-head',
            placement: 'bottom',
            title: 'Who does what',
            description:
                'Add the e-mail of each person per role. They sign in with their own account and only see their screen. Line judges need no entry here: they are your judge accounts and registered volunteers.',
            entries: [
                { label: 'settings.headJudges', ns: LIVE, text: 'start the waves and check the scores.' },
                { label: 'settings.speakers', ns: LIVE, text: 'follow the wave to announce it.' },
                { label: 'settings.regie', ns: LIVE, text: 'choose what the public screen shows.' },
            ],
        },
        {
            key: 'screen',
            target: '[data-tour="live-screen"]',
            placement: 'top',
            title: 'The public screen link',
            description: 'Copy this address onto the TV: no sign-in needed. Generate a new one if it leaked.',
        },
    ],
}

export default LIVE_SETTINGS_TOUR
